// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".CitationModal-cls1___b0e5c4e940d10720ec4{/*!*/}.CitationModal-cls2___91d41855fdbac58f6f4{cursor:pointer}.CitationModal-cls2___91d41855fdbac58f6f4:hover,.CitationModal-cls2___91d41855fdbac58f6f4:focus{color:#0645b1;color:var(--primary-brand, #0645b1)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "CitationModal-cls1___b0e5c4e940d10720ec4",
	"cls2": "CitationModal-cls2___91d41855fdbac58f6f4 CitationModal-cls1___b0e5c4e940d10720ec4"
};
export default ___CSS_LOADER_EXPORT___;
